import { CalendarModificationRelation } from "./CalendarModificationEntity";
import { CalendarModification_PlanningEventGeneratedEntity } from "./generated/CalendarModification_PlanningEventGeneratedEntity";
import { PlanningEventEntity } from "./PlanningEventEntity";

export abstract class CalendarModification_PlanningEventEntity
    extends CalendarModification_PlanningEventGeneratedEntity
    implements CalendarModificationRelation
{
    public get relatedEvents(): ReadonlyArray<PlanningEventEntity> {
        return this.planningEvent ? [this.planningEvent] : [];
    }
    // Comment to preserve new line
}
